// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fq","catalogByServiceItem__title":"c-k_fr"};